export const ENDPOINT_LEGAL_BASES_FIND_ALL = '/api/legal-bases/list';
export const ENDPOINT_LEGAL_BASES_CREATE_ONE = '/api/legal-bases/create';
export const ENDPOINT_LEGAL_BASES_UPDATE_ONE = '/api/legal-bases/update';
export const ENDPOINT_LEGAL_BASES_DELETE_ONE = '/api/legal-bases/delete';
export const ENDPOINT_LEGAL_BASES_GET_ONE = '/api/legal-bases/get-one';
